import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d231062&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3d231062&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=3d231062&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d231062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d231062')) {
      api.createRecord('3d231062', component.options)
    } else {
      api.reload('3d231062', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d231062&scoped=true", function () {
      api.rerender('3d231062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportForm/messageCenter/index.vue"
export default component.exports